import React, { useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import GroupLabel from '../GroupLabel/GroupLabel';
import Option from '../Option/Option';
import styles from './VirtualizedOptions.module.scss';

const DEFAULT_ITEM_HEIGHT = 32;

const VirtualizedOptions = ({ options }) => {
  const scrollElRef = useRef(null);

  const virtualizer = useVirtualizer({
    count: options.length,
    getScrollElement: () => scrollElRef.current,
    estimateSize: () => DEFAULT_ITEM_HEIGHT,
    overscan: 5,
    getItemKey: (index) => options[index].key || index,
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <div
      className={styles.root}
      ref={scrollElRef}
    >
      <div
        className={styles.wrapper}
        style={{ height: `${virtualizer.getTotalSize()}px` }}
      >
        <ul
          className={styles.itemsContainer}
          style={{
            transform: `translate3d(0, ${virtualItems[0]?.start ?? 0}px, 0)`,
          }}
        >
          {virtualItems.map(({ index, key }) => {
            const option = options[index];

            return (
              <li
                key={key}
                ref={virtualizer.measureElement}
                data-index={index}
              >
                {options.label ? (
                  <GroupLabel option={option} />
                ) : (
                  <Option option={option} />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default VirtualizedOptions;
